import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { NotEnoughStorageTemplate } from '../../components/Templates';
import useRedirectEntry from '../../hooks/useRedirectEntry';
import { useSessionStore } from '../../stores/SessionStore';
import { useUserStore } from '../../stores/UserStore';

const NotEnoughStorageScreen = () => {
  const navigate = useNavigate();

  useRedirectEntry({ allowTrial: false });

  const activeUserId = useSessionStore((store) => store.activeUserId);
  const account = useUserStore((state) => state.getAccount(activeUserId ?? ''));
  const profile = useUserStore((state) => state.getProfile(activeUserId ?? ''));
  const activeWebPlanTier = account?.activeWebPlanTier;
  const canUpgradeTier = activeWebPlanTier === undefined;

  const onClickCloudStorage = useCallback(() => {
    navigate('/cloud-storage');
  }, [navigate]);

  const onClickUpgrade = useCallback(() => {
    navigate('/subscription');
  }, [navigate]);

  return (
    <NotEnoughStorageTemplate
      tier={account?.activeWebPlanTier}
      createdItemCount={profile?.createdItemCount ?? 0}
      onClickCloudStorage={onClickCloudStorage}
      onClickUpgrade={canUpgradeTier ? onClickUpgrade : undefined}
    />
  );
};

export default NotEnoughStorageScreen;
